export default {
  0: { id: 0, title: '--- Select one ---' },
  1: { id: 13, title: 'Level 1' },
  2: { id: 14, title: 'Level 2' },
  3: { id: 15, title: 'Level 3' }
};
